import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';
import { SHARED_MODULES } from '../../../../shared.';

export const ELEMENT = new InjectionToken<string>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

@Component({
    selector: 'app-datetime-dtype',
    templateUrl: 'datetime-dtype.component.html',
	imports: [SHARED_MODULES],
    standalone: true
})
export class DatetimeDtypeComponent implements OnInit {
	element: string;

	constructor(@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<string>) {}

	ngOnInit(): void {
		this.element = this.elementInjected.element;
	}
}
